import React, {useEffect, useRef, useState} from "react";
import './animatedBlock.css';

const AnimatedBlock = ({ children }) => {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.disconnect(); // animate only once
                }
            },
            { threshold: 0.1 }
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => observer.disconnect();
    }, []);

    return (
        <div
            ref={ref}
            className={`animated-block ${visible ? "animate-in" : ""}`}
            // using div to wrap each section
        >
            {children}
        </div>
    );
};

export default AnimatedBlock;